import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
export var useMediaViewerListener = function useMediaViewerListener() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMediaOpen = _useState2[0],
    setIsMediaOpen = _useState2[1];
  var mediaMessageListener = useCallback(function (messageEvent) {
    var _messageEvent$data;
    var _ref = (_messageEvent$data = messageEvent.data) !== null && _messageEvent$data !== void 0 ? _messageEvent$data : {},
      source = _ref.source,
      event = _ref.event;
    if (!source || !event) {
      return;
    }
    if (source === 'media') {
      switch (event) {
        case 'mediaViewerOpened':
          setIsMediaOpen(true);
          break;
        case 'mediaViewerClosed':
          setIsMediaOpen(false);
          break;
        default:
          return;
      }
    }
  }, [setIsMediaOpen]);
  useEffect(function () {
    window.addEventListener('message', mediaMessageListener);
    return function () {
      return window.removeEventListener('message', mediaMessageListener);
    };
  }, [mediaMessageListener]);
  return {
    isMediaOpen: isMediaOpen
  };
};